<template>
  <div class="workbench">
    <div style="display: flex;justify-content: space-between">
      <UserCard></UserCard>
      <CapitalCard></CapitalCard>
    </div>
    <OrderCard></OrderCard>

    <orderItem
      :order_no="item.number"
      :product_img="item.product_img"
      :status_name="item.status_name"
      :created_at="item.created_at"
      :phone="item.phone"
      :address="item.address"
      :contact="item.contact"

      :service_name="item.service_name"
      :product_class="item.product_class"
      :product_number="item.product_number"
      :order_type="item.order_type"
      :price="item.price"
      :show_offer="getShowOffer(item)"
      :status="item.status"
      :id="item.id"
      v-for="(item,i) in orderData"
      :key="i"></orderItem>

  </div>
</template>

<script>
import UserCard from './components/userCard'
import OrderCard from './components/order/order'
import CapitalCard from './components/capital/capital'
import orderItem from '../order/components/order-item'
export default {
  components: { UserCard, OrderCard, CapitalCard, orderItem },
  name: 'workbench',
  data () {
    return {
      orderData: []
    }
  },
  created () {
    let vm = this
    vm.getOrder()
  },
  methods: {
    getShowOffer (order) {
      const offer = Array.isArray(order.offer_info) ? order.offer_info[0] : null
      if (offer && offer.show_offer !== undefined && offer.show_offer !== null && offer.show_offer !== '') {
        return offer.show_offer
      }
      return 0
    },
    getOrder () {
      let vm = this
      console.log(vm.searFrom)
      this.$request('6182826d5d0aa', {
        page: 1,
        limit: 10
        // type:vm.searFrom.type.toString(),
        // start_time:vm.searFrom.start_time,
        // end_time:vm.searFrom.end_time
      }).then(res => {
        // vm.tableShow.listCount = res.data.count
        vm.orderData = res.data.data
        // vm.tableData = res.data.data
        // vm.tableShow.listCount = res.data.count
        console.log('-----')
        console.log(vm.orderData)
      })
    }
  }
}
</script>

<style scoped lang="less">
.workbench {
  padding: 10px;

}
</style>
